module.exports = __webpack_public_path__ + "@/assets/img/047-girl-25.ea5780b3.svg";